import { Ref } from "vue";

type Entity = {
    id: string;
};

type LogEntityResponse = {
    members?: Array<Entity | null>;
    channels?: Array<Entity | null>;
};

export function mergeLogEntities(
    response: LogEntityResponse,
    refMembers: Ref<Map<string, Entity>>,
    refChannels: Ref<Map<string, Entity>>,
): void {
    for (const member of response.members ?? [])
        if (member)
            refMembers.value.set(member.id, member);

    for (const channel of response.channels ?? [])
        if (channel)
            refChannels.value.set(channel.id, channel);
}
